<template>
  <svg
    aria-hidden="true"
    fill="none"
    height="24"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.5"
    viewBox="0 0 24 24"
    width="24"
  >
    <rect height="16" rx="2.5" width="18" x="3" y="5" />
    <path d="M8 3v4" />
    <path d="M16 3v4" />
    <path d="M3 11h18" />
    <path d="M8 15h2" />
    <path d="M14 15h2" />
  </svg>
</template>
